import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ROOT } from './constants';
import axios from 'axios';
import { COGNITO_MAP } from './constants';
import { setForceLogout } from '../slices/auth/authSlice';
import { setSnackbarMessage, setSnackbarOpen } from '../slices/shared/sharedSlice';

const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem('refresh_token')
    try {
        const tokens = await axios.post(COGNITO_MAP["refresh"], {
            refresh_token: refreshToken
        })
        const access_token = tokens.data.access_token
        localStorage.setItem('access_token', access_token)
        console.log('==========================')
        console.log('Refreshed access token')
        console.log('==========================')
        return access_token
    } catch(e) {
        console.log(e);
        return null
    }
}

const baseQuery = fetchBaseQuery({
    baseUrl: ROOT,
    prepareHeaders(headers) {
        // set the token here
        const accessToken = localStorage.getItem('access_token');
        if(headers?.url?.includes('https://maps.googleapis.com'))
            return headers;

        headers.set('X-Authorization-Token', accessToken);
        return headers;
    }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    const originalStatus = result?.error?.originalStatus;
    const status = result?.error?.status;
    const errorOptions = [401, 403];

    if (result.error && errorOptions.includes(originalStatus || status)) {
        // Try to refresh the token
        const newToken = await refreshAccessToken();
        const forceLogout = api.getState().auth.forceLogout;
        if (newToken) {
            // Retry the original request with the new token
            localStorage.setItem('access_token', newToken);
            api.dispatch(setSnackbarMessage('Refreshed Session...'));
            api.dispatch(setSnackbarOpen(true));
            result = await baseQuery({
                ...args,
                headers: {
                    ...args.headers,
                    'X-Authorization-Token': newToken,
                },
            }, api, extraOptions);
        } else if(!forceLogout) {
            api.dispatch(setForceLogout(true));
        }
    }
    return result;
};

export default baseQueryWithReauth;
